module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_06-c0bcf4a399306e39f54e5a757adb6280.jpg";